/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m28.3477 17.8262c0 7.264-5.91 13.174-13.174 13.174s-13.174-5.91-13.174-13.174c0-6.927 5.377-12.609 12.174-13.123v-1.703h-.217c-.552 0-1-.448-1-1s.448-1 1-1h2.434c.553 0 1 .448 1 1s-.447 1-1 1h-.217v1.703c2.729.206 5.226 1.24 7.24 2.86l.998-.998-.206-.206c-.39-.39-.39-1.023 0-1.414.391-.39 1.024-.39 1.414 0l1.827 1.826c.39.39.39 1.023 0 1.414-.196.195-.452.293-.707.293-.256 0-.512-.098-.707-.293l-.206-.206-.958.958c2.152 2.346 3.479 5.461 3.479 8.889zm-2 0c0-6.161-5.013-11.174-11.174-11.174s-11.174 5.013-11.174 11.174 5.013 11.174 11.174 11.174 11.174-5.013 11.174-11.174zm-10.174-7.326v5.5c0 .552-.448 1-1 1s-1-.448-1-1v-5.5c0-.552.448-1 1-1s1 .448 1 1z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;